import React, { useContext, useState } from "react"
import { useQuery } from "react-query"
import MappingExternalField from "src/main/Accounting/MappingExternalField"
import { MAPPED, UNMAPPED } from "src/main/Accounting/constants"

import Badge from "src/components/Badge"
import { statusToken } from "src/components/Badge/status_tokens"
import DataTable from "src/components/DataTable"
import Loader from "src/components/Loader"

import { queryMappings } from "src/api/Accounting"

import { titlecase } from "src/utils/string_helpers"
import { updateUrlQueryParams } from "src/utils/url/parsing/marina"

import { AccountingContext } from "./AccountingView"

const RevenueMappingTab = () => {
  const { marinaSlug } = useContext(AccountingContext)
  const { selectedAccountingService } = useContext(AccountingContext)
  const urlParams = new URLSearchParams(window.location.search)
  const page = urlParams.get("page")
  const [currentAccountingPage, setCurrentAccountingPage] = useState(
    page ? parseInt(page) : 1
  )

  const selectOptions = (codeOptions) => {
    return (
      <>
        {codeOptions.map((codeOption) => {
          return (
            <option key={codeOption[1]} value={codeOption[1]}>
              {codeOption[0]}
            </option>
          )
        })}
      </>
    )
  }

  const COLDEFS = [
    {
      key: "generalLedgerCodeId",
      header: "Status",
      width: "200px",
      render: (data) => (
        <Badge
          color={statusToken(data.generalLedgerCodeId ? MAPPED : UNMAPPED)}
          text={
            data.generalLedgerCodeId ? titlecase(MAPPED) : titlecase(UNMAPPED)
          }
        />
      ),
    },
    {
      key: "displayName",
      header: "Dockwa Field",
    },
    {
      key: "externalField",
      header: "External Field",
      width: "280px",
      render: (data) => <MappingExternalField mapping={data} />,
    },
  ]

  const { data, error, isError, isLoading } = useQuery(
    ["accounting", "mapping-tab", "accounting", currentAccountingPage],
    () =>
      queryMappings({
        marinaSlug,
        collectionType: "accounting",
        page: currentAccountingPage,
      }),
    {
      retry: false,
      refetchOnWindowFocus: false,
    }
  )

  const handlePageChange = (selectedPage) => {
    setCurrentAccountingPage(selectedPage.selected)
    updateUrlQueryParams({
      mapping_tab: "accounting",
      page: selectedPage.selected,
    })
  }

  const renderMappingTable = () => {
    if (isLoading) {
      return (
        <div className="bg-white">
          <Loader name="revenue mappings" />
        </div>
      )
    } else if (isError) {
      return (
        <div className="text-muted bg-white p-5 text-center">
          <h3 className="mb-5">{error.message}</h3>
        </div>
      )
    } else if (data) {
      if (data.collection.length === 0) {
        return (
          <div className="text-muted bg-white p-5 text-center">
            <h3 className="mb-5">No mappings to display</h3>
          </div>
        )
      } else {
        const codeSelectOptions = selectOptions(data.codeOptions)

        return (
          <DataTable
            isLoading={isLoading}
            name="glcodes.mappings"
            colDefs={COLDEFS}
            rowData={data.collection.map((mapping) => ({
              ...mapping,
              codeSelectOptions,
              categoryKey: "accounting",
            }))}
            pagination
            page={currentAccountingPage}
            numberOfPages={data.totalPages}
            onPageChange={handlePageChange}
            hideActions
            hideSettings
          />
        )
      }
    }
  }

  return (
    <div>
      <h4 className="mb-1 pt-6 font-semibold text-gray-900">Revenue Mapping</h4>
      <div className="mb-8">
        <span className="text-gray-800">
          Map your {selectedAccountingService?.name || "Accounting System"}{" "}
          Accounts to Dockwa standard revenue fields.
        </span>
      </div>
      <div className="my-8">{renderMappingTable()}</div>
    </div>
  )
}

export default RevenueMappingTab
